module.exports = __webpack_public_path__ + "static/Truck10-b5c50e442c48948d6c2d43b3ca3a278f.png";